import BaseService from "./base.service";
import { Singleton } from "util";
import { ApiResourceBuilder } from "core/builder";

// TODO: Change from Product to Sellable
@Singleton
export default class VariationService extends BaseService {
  async fetch(_companyUuid, { filters, order, pagination, group }) {
    const url = `/v1/variations`;
    const resourceRoute = ApiResourceBuilder.buildFromParams(url, {
      filters,
      order,
      pagination,
      group
    });
    return await this.get(resourceRoute);
  }

  async create(params) {
    return await this.post(`/v1/variations`, params);
  }

  async fetchByUuid(variationUuid) {
    return await this.get(`/v1/variations/${variationUuid}`);
  }

  async update(variationUuid, params) {
    return await super.update(`/v1/variations/${variationUuid}`, params);
  }

  async delete(variationUuid) {
    return await this.destroy(`/v1/variations/${variationUuid}`);
  }
}



// WEBPACK FOOTER //
// ./src/core/service/variation.service.js